export const ME_QUERY = `
    query {
        me {
            id
            email
            status
            role { id name }
            permissions { id name }
        }
    }
`;

export const COUNT_PARAMS = `
    query {
        countParams {
            message
            conteo {
                technician
                client
                requests
                service
            }
        }
    }
`;

export const MONTH_TECHNICIAN = `
    query {
        dashboardTechnicianMonth {
            message
            content {
                month
                technicians_count
            }
        }
    }
`;

export const COUNT_TECHNICIAN = `
    query {
        countTechnicianDashboard {
            messge
            countTech {
                countTotal
                countActive
                countLow
            }
        }
    }
`;
export const COUNT_CLIENT  = `
    query {
        getContClient {
            message
            cont {
                clientAll
                clientActive
                clientLow
            }
        }
    }
`;
export const COUNT_REQUEST = `
    query {
        countRequest {
            message
            requestAll
            conteo {
                requestPending
                requestAccept
                requestCancel
                requestComple
                requestAnulad
                requestTermin
            }
        }
    }
`;
export const COUNT_SERVICE = `
    query {
        getCountService {
            message
            contAll
            contState {
                servicePending
                serviceFinish
                serviceComplt
                serviceAnull
            }
            contActivity {
                serviceMant
                serviceRepa
                serviceInst
                serviceInsp
            }
        }
    }
`;

export const FILTER_USER = `
    query ($email: String){
        filterUser (email: $email){
            message 
            user {
                id 
                email
                status
                roles {
                    name
                }
                permissions {
                    name
                }
            }
        }
    }
`;